import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icn-close.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3d96d543")

_pushScopeId("data-v-3d96d543")
const _hoisted_1 = { class: "search-tag-item-view" }
const _hoisted_2 = {
  class: "search-tag-item-close-icon",
  src: _imports_0
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "search-tag-item",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick(...args)), ["stop"])),
    style: { background: _ctx.getItemBackgroundColor() }
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: "commonTextCaption2 search-tag-item-label",
        style: { color: _ctx.getItemFontColor() }
      }, _toDisplayString(_ctx.label), 5),
      _withDirectives(_createVNode("img", _hoisted_2, null, 512), [
        [_vShow, _ctx.deleteIcon]
      ])
    ])
  ], 4))
})